import React from 'react';

class FieldsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection(e) {
    const optionValueArray = e.target.value.split('|');
    const operatorName = optionValueArray[0];
    const relatedObjectId = optionValueArray[1]
      ? Number(optionValueArray[1])
      : null;
    this.props.setOperator(operatorName, relatedObjectId);
  }

  static optionValue(field) {
    if (field.relatedObjectId) {
      return field.name + '|' + field.relatedObjectId;
    }
    return field.name;
  }

  render() {
    const { name, groupedFields } = this.props;
    return (
      <select
        className="Rule-select"
        value={name || ''}
        onChange={this.handleSelection}
        aria-label={t('smart_groups.create_modal.choose_rule_type')}
      >
        <option disabled value="">
          {t('smart_groups.create_modal.choose_rule_type')}
        </option>
        {Object.keys(groupedFields).map(label => (
          <optgroup label={label} key={label}>
            {groupedFields[label].map(field => (
              <option
                key={FieldsDropdown.optionValue(field)}
                value={FieldsDropdown.optionValue(field)}
              >
                {field.humanName}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    );
  }
}

export default FieldsDropdown;
